import styled from 'styled-components';
import { css } from 'styled-components';
import imgBg from '../assets/imgs-background/background1.png';

export const AdminPage = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 100vh;
  background: rgb(107, 107, 107);
  background: linear-gradient(180deg, rgba(107, 107, 107, 1) 0%, rgba(186, 186, 186, 1) 100%);
  background-image: url(${imgBg});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  nav {
    width: 80%;
    /* max-width: 90%; */
    margin-top: 35px;
    height: 45px;
    position: relative;
    overflow: auto;
    /* background: red; */
    ul {
      display: flex;
      gap: 40px;
      max-width: 100%;
      list-style: none;
      /* background: red; */
      height: 100%;
      li {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 30px;
        color: white;
        cursor: pointer;
        width: 50px;
        height: 100%;
        z-index: 2;
        max-width: 100%;
        img {
          width: 35px;
        }
      }
    }
  }
  .nav-list {
    position: relative;
    display: flex;
    list-style-type: none;
  }

  .nav-item {
    cursor: pointer;
    padding: 10px;
  }

  .nav-indicator {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 45px;
    background: rgba(0, 0, 0, 0.2);
    box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.2);
    backdrop-filter: blur(15px);
    -webkit-backdrop-filter: blur(15px);
    border-radius: 20px 20px 0px 0px;
    transition:
      width 0.3s,
      left 0.3s;
    z-index: 1;
  }

  .active {
    /* background: rgba(0, 0, 0, 0.2);
    box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.45);
    backdrop-filter: blur(15px);
    -webkit-backdrop-filter: blur(15px);
    border-radius: 20px 20px 0px 0px; */
  }
  .active .nav-indicator {
    width: 100%; /* largura total */
  }
  .disabled {
    opacity: 40%;
    cursor: not-allowed;
  }

  .teste {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 30px;
    width: 90%;
    background: red;
    height: 100%;
    min-height: 85vh;
    margin-left: 70px;
    margin-bottom: 100px;
    background: rgba(0, 0, 0, 0.2);
    box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.3);
    backdrop-filter: blur(15px);
    -webkit-backdrop-filter: blur(15px);
    border-radius: 10px;
    padding: 25px;
    img {
      width: 50%;
    }
  }
  @media (max-width: 800px) {
    nav {
      width: 65%;
    }
  }
  @media (max-width: 400px) {
    nav {
      width: 55%;
    }
    .teste {
      img {
        width: 90%;
      }
    }
  }
`;

const UserAdminBase = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 90%;
  background: red;
  height: 100%;
  min-height: 85vh;
  margin-left: 70px;
  margin-bottom: 100px;
  background: rgba(0, 0, 0, 0.2);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.15);
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  border-radius: 10px;
  padding: 25px;
  position: relative;
  .Header {
    display: flex;
    gap: 25px;
    align-items: center;
    h2 {
      font-size: 30px;
      color: white;
    }
    .addIcon {
      display: flex;
      gap: 10px;
      align-items: center;
      font-size: 30px;
      cursor: pointer;
      color: white;

      span {
        display: none;
        font-size: 20px;
        background: rgba(0, 0, 0, 0.3);
        padding: 5px 15px;
        border-radius: 13px;
        opacity: 60%;
        -webkit-animation: scale-in-hor-left 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
        animation: scale-in-hor-left 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
      }
      &:hover {
        span {
          display: inline;
        }
      }
    }
  }
  ul {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(340px, 1fr));
    align-items: stretch;
    width: 100%;
    height: 100%;
    gap: 24px;
    list-style: none;
    margin: 0;
    li {
      display: flex;
      flex-direction: column;
      gap: 15px;
      width: 100%;
      min-height: 40px;
      max-width: 100%;
      box-sizing: border-box;
      background: rgba(0, 0, 0, 0.6);
      border-radius: 10px;
      box-shadow: 0 0px 30px 0 rgba(232, 232, 232, 0.2);
      padding: 15px;
      color: rgba(203, 203, 203, 1);
      padding-top: 50px;
      position: relative;

      .iconEdit {
        position: absolute;
        top: 10px;
        right: 50px;
        font-size: 25px;
        cursor: pointer;
      }
      .btConfig {
        position: absolute;
        top: 12px;
        right: 80px;
        font-size: 21px;
        cursor: pointer;
      }
      .iconBin {
        position: absolute;
        top: 12px;
        right: 20px;
        font-size: 22px;
        cursor: pointer;
        transition: 0.5s;
      }
      .iconEdit:hover {
        color: white;
      }
      .btConfig:hover {
        color: white;
      }
      .iconBin:hover {
        color: red;
      }
      button {
        height: 40px;
        width: 100%;
        background: rgba(0, 0, 0, 0.2);
        border: 2px solid rgba(203, 203, 203, 0.3);
        color: rgba(203, 203, 203, 1);
        border-radius: 5px;
        cursor: pointer;
        transition: 0.5s;
      }
      button:hover {
        background: rgba(0, 0, 0, 0.6);
        color: white;
        border: 2px solid rgba(203, 203, 203, 0.8);
      }
    }
  }
  @media (max-width: 800px) {
    max-width: 80%;
    .Header {
    }
  }

  @media (max-width: 800px) {
    margin-left: 0px;
    width: 92%;
    max-width: 100%;
    ul {
      grid-template-columns: minmax(0, 1fr);
    }
    .Header {
      .addIcon {
        display: flex;
        gap: 10px;
        align-items: center;
        font-size: 30px;
        cursor: pointer;
        color: white;

        span {
          display: none;
          font-size: 20px;
          background: rgba(0, 0, 0, 0.3);
          padding: 5px 15px;
          border-radius: 13px;
          opacity: 60%;
          -webkit-animation: scale-in-hor-left 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
          animation: scale-in-hor-left 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
        }
        &:hover {
          span {
            display: none;
          }
        }
      }
    }
  }
`;

export const UserAdmin = styled(UserAdminBase)`
  gap: 24px;
  width: 90%;
  box-sizing: border-box;
  padding: 28px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 16px;
  background: rgba(0, 0, 0, 0.3);
  box-shadow: 0 18px 45px rgba(20, 42, 52, 0.2);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);

  .Header {
    justify-content: space-between;
    padding-bottom: 18px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.16);

    h2 {
      margin: 0;
      color: white;
      font-size: 32px;
      letter-spacing: -0.5px;
    }

    .addIcon {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 9px;
      min-height: 44px;
      box-sizing: border-box;
      padding: 0 17px;
      border: 1px solid rgba(190, 202, 255, 0.7);
      border-radius: 10px;
      background: #4c5fb7;
      box-shadow: 0 6px 16px rgba(32, 43, 94, 0.25);
      color: white;
      font-family: inherit;
      font-size: 15px;
      font-weight: 700;
      cursor: pointer;
      transition:
        background 0.2s,
        border-color 0.2s,
        transform 0.2s,
        box-shadow 0.2s;

      svg {
        font-size: 21px;
      }

      span {
        display: inline;
        padding: 0;
        border-radius: 0;
        background: transparent;
        font-size: 15px;
        opacity: 1;
        animation: none;
      }

      &:hover {
        border-color: #d7defd;
        background: #5a6dcc;
        box-shadow: 0 8px 20px rgba(32, 43, 94, 0.32);
        transform: translateY(-1px);

        span {
          display: inline;
        }
      }
    }
  }

  .userFilters {
    display: grid;
    grid-template-columns: auto minmax(0, 1fr) minmax(260px, 340px);
    align-items: center;
    gap: 16px;
    padding: 14px;
    border: 1px solid rgba(255, 255, 255, 0.16);
    border-radius: 12px;
    background: rgba(18, 40, 49, 0.48);

    .filterHeading {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      color: #fff;
      font-size: 14px;
      font-weight: 800;

      svg {
        font-size: 18px;
      }
    }

    .filterTabs {
      display: flex;
      align-items: center;
      gap: 8px;
      min-width: 0;
      overflow-x: auto;
      scrollbar-width: thin;

      button {
        display: inline-flex;
        align-items: center;
        gap: 7px;
        flex: 0 0 auto;
        min-height: 38px;
        padding: 0 12px;
        border: 1px solid rgba(210, 224, 230, 0.3);
        border-radius: 9px;
        background: rgba(255, 255, 255, 0.08);
        color: #e9f0f3;
        font-family: inherit;
        font-size: 13px;
        font-weight: 700;
        cursor: pointer;
        transition: 0.2s;

        strong {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-width: 21px;
          height: 21px;
          padding: 0 5px;
          border-radius: 999px;
          background: rgba(255, 255, 255, 0.14);
          font-size: 11px;
        }

        &:hover {
          border-color: rgba(222, 230, 255, 0.72);
          background: rgba(255, 255, 255, 0.15);
        }

        &.activeFilter {
          border-color: #aebcff;
          background: #4c5fb7;
          color: #fff;
          box-shadow: 0 5px 14px rgba(29, 42, 99, 0.25);
        }
      }
    }

    .userSearch {
      display: flex;
      align-items: center;
      gap: 9px;
      min-width: 0;
      height: 40px;
      box-sizing: border-box;
      padding: 0 12px;
      border: 1px solid rgba(210, 224, 230, 0.42);
      border-radius: 9px;
      background: rgba(247, 249, 250, 0.96);
      color: #617780;

      svg {
        flex: 0 0 auto;
        font-size: 18px;
      }

      input {
        width: 100%;
        min-width: 0;
        border: 0;
        outline: 0;
        background: transparent;
        color: #20343d;
        font-family: inherit;
        font-size: 13px;

        &::placeholder {
          color: #7a8d95;
        }
      }

      &:focus-within {
        border-color: #9aaaf4;
        box-shadow: 0 0 0 3px rgba(76, 95, 183, 0.16);
      }
    }
  }

  .filterResult {
    display: flex;
    justify-content: flex-end;
    margin: -12px 2px -8px;
    color: rgba(238, 245, 247, 0.82);
    font-size: 12px;
    font-weight: 700;
  }

  .emptyUsers {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 7px;
    min-height: 220px;
    padding: 28px;
    border: 1px dashed rgba(255, 255, 255, 0.3);
    border-radius: 13px;
    background: rgba(18, 40, 49, 0.32);
    color: #fff;
    text-align: center;

    span {
      color: rgba(238, 245, 247, 0.75);
      font-size: 13px;
    }
  }

  ul {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(410px, 1fr));
    align-items: stretch;
    gap: 22px;
    width: 100%;
    margin: 0;
    padding: 0;

    li {
      display: flex;
      flex-direction: column;
      gap: 18px;
      width: auto;
      min-height: 0;
      max-width: none;
      box-sizing: border-box;
      padding: 20px;
      border: 1px solid rgba(82, 111, 124, 0.22);
      border-top: 4px solid #557d8d;
      border-radius: 14px;
      background: rgba(247, 249, 250, 0.96);
      color: #20343d;
      box-shadow: 0 12px 28px rgba(21, 42, 51, 0.16);

      &.onlineUser {
        border-top-color: #2fa84f;
        box-shadow: 0 12px 28px rgba(31, 123, 57, 0.14);
      }

      &.offlineUser {
        border-top-color: #6f8d99;
      }

      .userCardTop {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        min-height: 34px;
      }

      .userStatus {
        position: static;
        display: inline-flex;
        width: max-content;
        padding: 6px 9px;
        border-radius: 8px;
        background: #edf2f4;
        color: #4e626b;
        font-size: 13px;
        font-weight: 700;
      }

      .userActions {
        display: flex;
        align-items: center;
        gap: 6px;

        button {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 34px;
          height: 34px;
          padding: 0;
          border: 1px solid #d1dce0;
          border-radius: 8px;
          background: #f4f7f8;
          color: #58717b;
          font-size: 17px;
          cursor: pointer;
          transition:
            background 0.2s,
            border-color 0.2s,
            color 0.2s;

          &:hover {
            border-color: #9eb0b8;
            background: #e4ecef;
            color: #29434e;
          }
        }

        .deleteUser:hover {
          border-color: #efb8b8;
          background: #fbe9e9;
          color: #b84343;
        }
      }

      .userIdentity {
        display: flex;
        align-items: center;
        gap: 13px;
        padding-bottom: 16px;
        border-bottom: 1px solid #dbe3e7;

        .userAvatar {
          display: flex;
          align-items: center;
          justify-content: center;
          flex: 0 0 48px;
          width: 48px;
          height: 48px;
          border-radius: 13px;
          background: #e8eeff;
          color: #4c5fb7;
          font-size: 21px;
          font-weight: 800;
        }

        h3 {
          margin: 0 0 4px;
          color: #1b3039;
          font-size: 18px;
          line-height: 1.25;
        }

        div > span {
          color: #6b7d84;
          font-size: 13px;
        }

        .userMeta {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 8px;

          > span {
            color: #6b7d84;
            font-size: 13px;
          }

          .categoryBadge {
            padding: 3px 7px;
            border-radius: 999px;
            background: #e5eaec;
            color: #4f626a;
            font-size: 10px;
            font-weight: 800;
            letter-spacing: 0.35px;
            text-transform: uppercase;

            &.gtw {
              background: #e7edff;
              color: #4358ad;
            }

            &.tanques {
              background: #e0f1e6;
              color: #28723c;
            }
          }
        }
      }

      .userInfoGrid {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 14px;

        > div {
          display: flex;
          flex-direction: column;
          gap: 5px;
          min-width: 0;
          padding: 11px 12px;
          border: 1px solid #d7e0e4;
          border-radius: 9px;
          background: #eef3f5;
        }

        .emailInfo {
          grid-column: 1 / -1;
        }

        .infoLabel {
          color: #667980;
          font-size: 11px;
          font-weight: 800;
          letter-spacing: 0.45px;
          text-transform: uppercase;
        }

        .infoValue {
          overflow: hidden;
          color: #2a4049;
          font-size: 14px;
          font-weight: 700;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .infoBadge {
          width: max-content;
          padding: 4px 8px;
          border-radius: 999px;
          font-size: 12px;
          font-weight: 800;
        }

        .activeBadge {
          background: #dff2e4;
          color: #28723c;
        }

        .inactiveBadge {
          background: #f6e1e1;
          color: #9d3f3f;
        }
      }

      .userButtons {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 10px;
        margin-top: auto;

        button {
          height: 40px;
          border: 1px solid #9eb0b8;
          border-radius: 8px;
          background: #f6f8f9;
          color: #31464f;
          font-family: inherit;
          font-weight: 700;

          &:hover {
            border-color: #617f8c;
            background: #e5edef;
            color: #223840;
          }
        }

        .primaryButton {
          border-color: #4c5fb7;
          background: #4c5fb7;
          color: white;

          &:hover {
            border-color: #4355a7;
            background: #4355a7;
            color: white;
          }
        }
      }
    }
  }

  @media (max-width: 800px) {
    width: 92%;
    max-width: 100%;
    padding: 16px;

    .Header {
      align-items: stretch;
      flex-direction: column;
      gap: 14px;

      .addIcon {
        width: 100%;

        span {
          display: inline;
        }
      }
    }

    .userFilters {
      grid-template-columns: minmax(0, 1fr);
      gap: 12px;

      .filterHeading {
        display: none;
      }

      .userSearch {
        grid-row: 1;
      }
    }

    ul {
      grid-template-columns: minmax(0, 1fr);

      li {
        padding: 17px;

        .userInfoGrid,
        .userButtons {
          grid-template-columns: minmax(0, 1fr);
        }

        .userInfoGrid .emailInfo {
          grid-column: 1;
        }
      }
    }
  }
`;

export const Dot = styled.span`
  position: absolute;
  background: rgba(0, 0, 0, 1);
  width: 20px;
  height: 20px;
  border-radius: 50%;
  top: 0;
  transition: 0.5s;
  ${({ isLeft }) =>
    isLeft
      ? css`
          left: 2px;
        `
      : css`
          left: 19px;
        `}
`;

export const StatusUser = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  position: absolute;
  top: 14px;
  .online {
    width: 14px;
    height: 14px;
    background-color: ${(props) => props.color};
    border-radius: 50%;
  }
`;

export const AdminTanque = styled.main`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 90%;
  height: 100%;
  min-height: 85vh;
  margin-left: 70px;
  margin-bottom: 100px;
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0.3);
  box-shadow: 0 18px 45px rgba(20, 42, 52, 0.2);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  border-radius: 16px;
  padding: 28px;

  .Header {
    display: flex;
    gap: 25px;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    h2 {
      font-size: 30px;
      color: white;
    }
    .headerActions {
      display: flex;
      align-items: center;
      gap: 22px;
      margin-left: auto;
    }
    .addIcon {
      display: flex;
      gap: 10px;
      align-items: center;
      font-size: 30px;
      cursor: pointer;
      color: white;
      .icons {
        position: relative;
        img {
          width: 40px;
        }
        .pivoIcon {
          font-size: 40px;
        }
        .ADDIcon {
          position: absolute;
          left: 25px;
          top: 0px;
          background: white;
          border-radius: 50%;
          color: black;
          font-size: 28px;
          opacity: 80%;
        }
      }

      span {
        display: none;
        font-size: 20px;
        background: rgba(0, 0, 0, 0.3);
        padding: 5px 15px;
        border-radius: 13px;
        opacity: 60%;
        -webkit-animation: scale-in-hor-left 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
        animation: scale-in-hor-left 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
      }
      &:hover {
        span {
          display: inline;
        }
      }
    }
    .downloadApp {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 9px;
      min-height: 42px;
      padding: 0 18px;
      border: 1px solid rgba(255, 255, 255, 0.55);
      border-radius: 9px;
      background: rgba(25, 118, 62, 0.9);
      box-shadow: 0 5px 16px rgba(0, 0, 0, 0.18);
      color: white;
      font-size: 16px;
      font-weight: 600;
      text-decoration: none;
      transition:
        background 0.2s,
        transform 0.2s,
        box-shadow 0.2s;

      svg {
        flex: 0 0 auto;
        font-size: 23px;
      }

      &:hover {
        background: rgba(19, 138, 66, 1);
        box-shadow: 0 7px 20px rgba(0, 0, 0, 0.25);
        transform: translateY(-1px);
      }
    }
  }

  .tankSearchBar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 18px;
    padding: 14px;
    border: 1px solid rgba(255, 255, 255, 0.16);
    border-radius: 12px;
    background: rgba(18, 40, 49, 0.48);

    label {
      display: flex;
      align-items: center;
      gap: 9px;
      width: min(100%, 430px);
      height: 42px;
      box-sizing: border-box;
      padding: 0 13px;
      border: 1px solid rgba(210, 224, 230, 0.42);
      border-radius: 9px;
      background: rgba(247, 249, 250, 0.96);
      color: #617780;

      svg {
        flex: 0 0 auto;
        font-size: 18px;
      }

      input {
        width: 100%;
        min-width: 0;
        border: 0;
        outline: 0;
        background: transparent;
        color: #20343d;
        font-family: inherit;
        font-size: 13px;

        &::placeholder {
          color: #7a8d95;
        }
      }

      &:focus-within {
        border-color: #9aaaf4;
        box-shadow: 0 0 0 3px rgba(76, 95, 183, 0.16);
      }
    }

    > span {
      flex: 0 0 auto;
      color: rgba(238, 245, 247, 0.86);
      font-size: 12px;
      font-weight: 700;
    }
  }

  .emptyTanks {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 7px;
    min-height: 220px;
    padding: 28px;
    border: 1px dashed rgba(255, 255, 255, 0.3);
    border-radius: 13px;
    background: rgba(18, 40, 49, 0.32);
    color: #fff;
    text-align: center;

    span {
      color: rgba(238, 245, 247, 0.75);
      font-size: 13px;
    }
  }

  ul {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 30px;
    width: 100%;
    max-width: 100%;
    flex-wrap: wrap;
    li {
      display: flex;
      flex-direction: column;
      gap: 20px;
      width: 350px;
      background-color: rgba(222, 222, 222, 0.9);
      box-shadow: 0 3px 20px 0 rgba(31, 38, 135, 0.2);
      backdrop-filter: blur(4px);
      -webkit-backdrop-filter: blur(4px);
      border-radius: 8px;
      border: 1px solid rgba(255, 255, 255, 0.18);
      list-style: none;
      padding: 15px;
      max-width: 100%;
      .headerTanqueInfo {
        display: flex;
        align-items: center;
        gap: 5px;
        width: 90%;

        /* background: red; */
        input {
          padding: 5px 2px;
          font-size: 22px;
          font-weight: 600;
          border: none;
          background: none;
          /* background: blue; */
          max-width: 60%;
        }
        label {
          font-size: 25px;
        }
        .iconBin {
          position: absolute;
          right: 20px;
          top: 19px;
          font-size: 19px;
          cursor: pointer;
          transition: 0.5s;
          color: rgba(48, 48, 48, 1);
        }
        .iconBin:hover {
          color: rgba(150, 14, 14, 1);
        }
      }
      .infosPivo {
        display: flex;
        flex-direction: column;
        gap: 20px;
        position: relative;
        height: 47px;
        /* background: red; */
        p {
          font-weight: 600;
        }
        label {
          font-weight: 600;
          color: rgba(62, 62, 62, 1);
          background: linear-gradient(to top, rgba(222, 222, 222, 1) 50%, transparent 50%);
          max-width: max-content;
          padding: 0px 4px;
          position: absolute;
          top: -9.9px;
          left: 15px;
          text-shadow: -1px -2px 8px rgba(255, 255, 255, 0.8);
        }
        input,
        select {
          width: 100%;
          height: 47px;
          padding: 15px 20px;
          border-radius: 15px;
          border: 1px solid black;
          background-color: rgba(222, 222, 222, 1);
          box-shadow: 0px -14px 55px -4px rgba(0, 0, 0, 0.3);
          -webkit-box-shadow: 0px -14px 55px -4px rgba(0, 0, 0, 0.3);
          -moz-box-shadow: 0px -14px 55px -4px rgba(0, 0, 0, 0.3);
        }
        select {
          padding-top: 0;
          padding-bottom: 0;
          color: rgba(38, 38, 38, 1);
          cursor: pointer;
        }
        .selectBomb {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 20px;
          max-width: 100%;
          .select {
            width: 100px;
            max-width: 100%;
            overflow-x: auto;
          }
          button {
            width: 40px;
            min-width: 40px;
            height: 20px;
            border-radius: 50px;
            border: none;
            position: relative;
            cursor: pointer;
            background: white;
          }
        }
      }
      .buttons {
        display: flex;
        justify-content: center;
        gap: 8px;
        button {
          width: 100%;
          height: 30px;
          cursor: pointer;
          border-radius: 5px;
          border: 1px solid rgba(39, 39, 39, 0.8);
          transition: 0.5s;
        }
        .bombsSelect {
          border-radius: 10px;
          font-size: 15px;
          width: 32%;
        }
        .off {
          opacity: 60%;
          cursor: not-allowed;
        }
      }
      button:hover {
        background-color: white;
      }
    }
  }

  /* Tema da tela de configuração */
  .Header {
    padding-bottom: 18px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.16);

    h2 {
      margin: 0;
      font-size: 32px;
      letter-spacing: -0.5px;
    }

    .headerActions {
      gap: 12px;
    }

    .addIcon,
    .downloadApp {
      min-height: 44px;
      box-sizing: border-box;
      border-radius: 10px;
      font-size: 15px;
      font-weight: 700;
      font-family: inherit;
      cursor: pointer;
      transition:
        background 0.2s,
        border-color 0.2s,
        transform 0.2s,
        box-shadow 0.2s;
    }

    .addIcon {
      padding: 0 16px;
      border: 1px solid rgba(255, 255, 255, 0.35);
      background: rgba(255, 255, 255, 0.1);

      .icons {
        display: flex;
        align-items: center;

        img {
          width: 30px;
        }

        .ADDIcon {
          left: 19px;
          top: -3px;
          font-size: 21px;
        }
      }

      span {
        display: inline;
        padding: 0;
        border-radius: 0;
        background: transparent;
        font-size: 15px;
        opacity: 1;
        animation: none;
      }

      &:hover {
        border-color: rgba(255, 255, 255, 0.65);
        background: rgba(255, 255, 255, 0.18);
        transform: translateY(-1px);
      }
    }

    .downloadApp {
      padding: 0 17px;
      border-color: rgba(190, 202, 255, 0.7);
      background: #4c5fb7;
      box-shadow: 0 6px 16px rgba(32, 43, 94, 0.25);

      svg {
        font-size: 21px;
      }

      &:hover {
        border-color: #d7defd;
        background: #5a6dcc;
        box-shadow: 0 8px 20px rgba(32, 43, 94, 0.32);
      }
    }
  }

  ul {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(410px, 1fr));
    align-items: stretch;
    gap: 22px;
    padding: 0;
    margin: 0;

    li {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      align-content: start;
      gap: 15px 14px;
      width: auto;
      padding: 20px;
      box-sizing: border-box;
      position: relative;
      overflow: hidden;
      border: 1px solid rgba(82, 111, 124, 0.22);
      border-top: 4px solid #557d8d;
      border-radius: 14px;
      background: rgba(247, 249, 250, 0.96);
      box-shadow: 0 12px 28px rgba(21, 42, 51, 0.16);

      .headerTanqueInfo {
        grid-column: 1 / -1;
        width: 100%;
        min-height: 38px;
        padding-bottom: 8px;
        border-bottom: 1px solid #dbe3e7;

        input {
          width: calc(100% - 80px);
          max-width: none;
          padding: 2px 0;
          color: #182a32;
          font-size: 22px;
          line-height: 1.2;
          outline: none;
        }

        label {
          display: inline-flex;
          color: #496b79;
          cursor: pointer;
        }

        .iconBin {
          top: 22px;
          color: #6f7f86;
        }
      }

      .infosPivo {
        height: auto;
        min-width: 0;
        gap: 6px;

        p,
        label {
          position: static;
          margin: 0;
          padding: 0;
          background: none;
          color: #435861;
          font-size: 13px;
          font-weight: 700;
          line-height: 1.25;
          text-shadow: none;
        }

        input,
        select {
          width: 100%;
          height: 42px;
          box-sizing: border-box;
          padding: 0 12px;
          border: 1px solid #c6d2d8;
          border-radius: 8px;
          outline: none;
          background: #ffffff;
          box-shadow: none;
          color: #22343c;
          font-size: 14px;
          transition:
            border-color 0.2s,
            box-shadow 0.2s;

          &:focus {
            border-color: #587aaf;
            box-shadow: 0 0 0 3px rgba(88, 122, 175, 0.14);
          }

          &:disabled {
            background: #edf1f3;
            color: #64747b;
          }
        }

        select {
          padding: 0 10px;
        }
      }

      .statusInfo {
        grid-column: 1 / -1;
        display: flex;
        align-items: center;
        padding: 12px 14px;
        border: 1px solid #d7e0e4;
        border-radius: 10px;
        background: #eef3f5;

        .selectBomb {
          justify-content: flex-start;
          gap: 12px;

          .select {
            width: auto;
            color: #354950;
            font-size: 14px;
          }

          button {
            background: #d5dde1;
          }
        }
      }

      .buttons {
        grid-column: 1 / -1;
        gap: 10px;

        button {
          min-height: 38px;
          height: 38px;
          border: 1px solid #9eb0b8;
          border-radius: 8px;
          background: #f6f8f9;
          color: #31464f;
          font-weight: 700;
        }

        button:hover:not(:disabled) {
          border-color: #617f8c;
          background: #e5edef;
        }

        button:disabled,
        .off {
          opacity: 0.48;
          cursor: not-allowed;
        }

        .bombsSelect {
          width: auto;
          min-width: 130px;
          border-color: #587aaf;
          background: #587aaf;
          color: white;
        }

        .bombsSelect:hover:not(:disabled) {
          border-color: #496b9f;
          background: #496b9f;
        }
      }
    }
  }

  @media (max-width: 650px) {
    max-width: 90%;
    margin-left: 0px;
    margin-bottom: 120px;
    width: 92%;
    max-width: 100%;
    padding: 16px;

    .Header {
      align-items: flex-start;
      gap: 14px;

      .headerActions {
        width: 100%;
        margin-left: 0;
        flex-wrap: wrap;
      }

      .downloadApp {
        flex: 1 1 210px;
        min-height: 40px;
        padding: 0 13px;
        font-size: 14px;
      }

      .addIcon {
        flex: 1 1 150px;
        justify-content: center;
      }
    }

    .tankSearchBar {
      align-items: stretch;
      flex-direction: column;
      gap: 10px;

      label {
        width: 100%;
      }

      > span {
        align-self: flex-end;
      }
    }

    ul {
      grid-template-columns: minmax(0, 1fr);

      li {
        grid-template-columns: minmax(0, 1fr);

        .headerTanqueInfo,
        .statusInfo,
        .buttons {
          grid-column: 1;
        }
      }
    }
  }
`;
